import { authAxios as axios } from "shared-auth";
import queryString from "query-string";

import {
  ISelfTapeRequestInviteListFilterParams,
  ISelfTapeRequestsListFilterParams,
} from "shared/models/api";
import {
  ISelfTapeRequest,
  ISelfTapeRequestInviteList,
  ISelfTapeRequestsList,
  ISubmission,
  ISubmissionDetails,
} from "shared/models/selfTapeRequest";

import config from "config/global";

class SelfTapeRequestService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async getSelfTapeRequest(
    selfTapeRequestId: string,
    abortController?: AbortController
  ): Promise<ISelfTapeRequest> {
    return this.getRequest(
      `${this.url}/selftaperequest/${selfTapeRequestId}`,
      abortController
    );
  }

  public async getSelfTapeRequestForPerformerByPerformerRequestId(
    performerRequestId: string,
    abortController?: AbortController
  ): Promise<ISelfTapeRequest> {
    return this.getRequest(
      `${this.url}/submission/performerrequest/${performerRequestId}`,
      abortController
    );
  }

  public async findSelfTapeRequests(
    params: ISelfTapeRequestsListFilterParams,
    abortController?: AbortController
  ): Promise<ISelfTapeRequestsList> {
    const response = await axios(`${this.url}/selftaperequest`, {
      params,
      paramsSerializer: (param) => queryString.stringify(param),
      signal: abortController?.signal,
    });

    return response.data;
  }

  public async findSelfTapeRequestInvitations(
    selfTapeRequestId: string,
    params: ISelfTapeRequestInviteListFilterParams,
    abortController?: AbortController
  ): Promise<ISelfTapeRequestInviteList> {
    const response = await axios(
      `${this.url}/selftaperequest/${selfTapeRequestId}/invite`,
      {
        params,
        paramsSerializer: (param) => queryString.stringify(param),
        signal: abortController?.signal,
      }
    );

    return response.data;
  }

  public async createSelftapeSubmissionByPerformerRequestId(
    performerRequestId: string,
    submissionDetails: ISubmissionDetails
  ): Promise<ISubmission> {
    const response = await axios(
      `${this.url}/submission/performerrequest/${performerRequestId}`,
      {
        method: "post",
        data: submissionDetails,
      }
    );

    return response.data;
  }

  public async publishSelftapeSubmissionByPerformerRequestId(
    performerRequestId: string,
    submissionId: string
  ): Promise<ISubmission> {
    const response = await axios(
      `${this.url}/submission/performerrequest/${performerRequestId}/${submissionId}/publish`,
      {
        method: "post",
      }
    );

    return response.data;
  }

  private async getRequest(
    getUrl: string,
    abortController?: AbortController
  ): Promise<ISelfTapeRequest> {
    const response = await axios(getUrl, {
      signal: abortController?.signal,
    });

    return response.data;
  }
}

export const selfTapesApiUrl = config.selfTapesApiUrl;

export default new SelfTapeRequestService({
  url: selfTapesApiUrl,
});
